import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { DemographicAppKeys, DemographicsContext } from '../../../../global/models/demographics-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { MidYearProps } from '../../../arc/models/arc-epi-props';
import { PointOfContactDepentType, PointOfContactFormModel, PointOfContactPageModel } from '../mycpg-midyear/models/mycpg-mid-year-models';
import { MyCPGMidYearProps } from '../mycpg-midyear/models/mycpg-midyear-epi-props';
import { PointOfContactForm } from './point-of-contact-form';

interface Props {
    isMyCpg?: boolean,
    dependentType: PointOfContactDepentType,
    onSubmitHandler: (pointOfContactFormValues: PointOfContactFormModel) => void;
    onCancelHandler: () => void;
}
function PointOfContactPage(props: Props) {
    const { isMyCpg, dependentType, onSubmitHandler, onCancelHandler } = props;
    const myCPGMidYearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);
    const midYearSettings = useSelector<TcsmStates, MidYearProps>(a => a.epiProps?.midYearSettingsState?.epiContent);

    const dispatch = useDispatch();

    const app = useContext(DemographicsContext);
    const isArcApp = app === DemographicAppKeys.arc;

    const myCPGmidyearLoaded = isArcApp ? true : useSelector<TcsmStates, boolean>(state => state.epiProps.myCpgMidyearSettingsState?.contentLoaded);
    const arcMidyearLoaded = isArcApp ? midYearSettings : true;

    const settingPage: MyCPGMidYearProps | MidYearProps = isArcApp ? midYearSettings : myCPGMidYearSettings;

    const model: PointOfContactPageModel = {
        pageTitle: settingPage?.pointOfContactPageTitle,
        pageDescription: settingPage?.pointOfContactPageDescription,
        isContactPersonLabel: settingPage?.isContactPersonLabel,
        fullNameContactLabel: settingPage?.fullNameContactLabel,
        yourContactPhoneLabel: settingPage?.yourContactPhoneLabel,
        yourContactEmailLabel: settingPage?.yourContactEmailLabel,
        relationshipToDeceasedLabel: settingPage?.relationshipToDeceasedLabel,
        contactPhoneLabel: settingPage?.contactPhoneLabel,
        contactEmailLabel: settingPage?.contactEmailLabel,
        continueButtonText: settingPage?.pointOfContactContinueButtonText,
        cancelButtonText: settingPage?.pointOfContactCancelButtonText,
        dependentType,
    };

    useEffect(() => {
        dispatch(apiErrorClear());
    }, []);

    if (isArcApp === isMyCpg) {
        return null;
    }

    if (!myCPGmidyearLoaded || !arcMidyearLoaded) {
        return <LoadingCircle />;
    }

    if (!model) {
        return null;
    }

    return (
        <PointOfContactForm model={model} onSubmitHandler={onSubmitHandler} onCancelHandler={onCancelHandler} />
    );
}

PointOfContactPage.defaultProps = {
    isMyCpg: false,
};

export default PointOfContactPage;